import { HelpCircle, User, Pencil, Copy, Trash2, Image as ImageIcon } from 'lucide-react';
import { formatDistanceToNow } from '../../utils/dateUtils';

export default function QuizCard({ quiz, onHostGame, onEdit, onDelete, onCopy }) {
  const questionCount = quiz.questions?.length || 0;
  const playCount = quiz.playCount || 0;
  const coverImage = quiz.questions?.[0]?.imageUrl || null;
  const updatedAt = quiz.updatedAt ? formatDistanceToNow(quiz.updatedAt) : 'Nyleg';

  return (
    <div className="group flex flex-col rounded-[20px] bg-white border border-[rgba(17,73,66,0.12)] shadow-mp-1 overflow-hidden hover:shadow-mp-2 transition-all duration-300">
      {/* Image */}
      <div className="relative h-44 w-full overflow-hidden">
        {coverImage ? (
          <div
            className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
            style={{ backgroundImage: `url("${coverImage}")` }}
          />
        ) : (
          <div className="absolute inset-0 bg-gradient-to-br from-mp-bg-mint to-mp-teal flex items-center justify-center">
            <ImageIcon size={48} className="text-white/60" />
          </div>
        )}
      </div>

      {/* Content */}
      <div className="flex w-full flex-col gap-3 p-5">
        <div>
          <h4 className="font-display text-lg text-mp-darkgreen leading-snug">{quiz.title}</h4>
          <p className="font-body text-mp-stone-500 text-sm mt-1">Oppdatert {updatedAt}</p>
        </div>

        {/* Stats badges */}
        <div className="flex items-center gap-2.5">
          <span className="inline-flex items-center gap-1.5 bg-mp-bg-lightgreen text-mp-darkgreen font-display text-xs px-3 py-1.5 rounded-full">
            <HelpCircle size={14} />
            {questionCount} spm
          </span>
          <span className="inline-flex items-center gap-1.5 bg-mp-bg-lightgreen text-mp-darkgreen font-display text-xs px-3 py-1.5 rounded-full">
            <User size={14} />
            {playCount} spelt
          </span>
        </div>

        {/* Action buttons */}
        <div className="mt-2 flex gap-2.5">
          <button onClick={() => onHostGame(quiz)} className="mp-cta flex-1 !py-2.5 !text-sm">
            Start spel
          </button>
          <button
            onClick={() => onEdit(quiz)}
            className="flex items-center justify-center w-10 h-10 rounded-full bg-mp-bg-lightgreen text-mp-darkgreen hover:bg-mp-bg-mint transition-colors"
            title="Rediger"
          >
            <Pencil size={18} />
          </button>
          {onCopy && (
            <button
              onClick={() => onCopy(quiz)}
              className="flex items-center justify-center w-10 h-10 rounded-full bg-mp-bg-lightgreen text-mp-darkgreen hover:bg-mp-bg-blue hover:text-mp-teal transition-colors"
              title="Kopier"
            >
              <Copy size={18} />
            </button>
          )}
          <button
            onClick={() => onDelete(quiz)}
            className="flex items-center justify-center w-10 h-10 rounded-full bg-mp-bg-pink text-mp-magenta hover:bg-[rgba(163,0,97,0.15)] transition-colors"
            title="Slett"
          >
            <Trash2 size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
